﻿export class AuthData {
    access_token: string = "";
    refresh_token: string = "";
    expires_in: number = 0;
}

export class AuthDataV2 {
  authenticationResult: AuthDetails = new AuthDetails();
}

export class AuthDetails {
  expiresIn: number = 0;
  tokenType: string = "";
  refreshToken: string = "";
  idToken: string = "";
  accessToken: string = "";
}
